<section class="landing-a__section landing-a__section--muted" id="pricing">
  <div class="landing-a__container">
    <div class="landing-a__section-heading">
      <h2>{{ 'landing.landing_1.pricing.title' | translate }}</h2>
      <p>{{ 'landing.landing_1.pricing.subtitle' | translate }}</p>
    </div>

    <div class="landing-a__pricing-grid">
      @for (tier of pricingTiers; track tier.key) {
        <article
          class="landing-a__pricing-card"
          [class.landing-a__pricing-card--featured]="tier.featured"
          [class.landing-a__pricing-card--contact]="tier.contact"
        >
          @if (tier.featured) {
            <span class="landing-a__pricing-badge">
              {{ 'landing.landing_1.pricing.featured_badge' | translate }}
            </span>
          }

          <div class="landing-a__pricing-card-body">
            <div class="landing-a__pricing-range">
              <span class="landing-a__pricing-range-value">
                {{ 'landing.landing_1.pricing.tiers.' + tier.key + '.range' | translate }}
              </span>
              <span class="landing-a__pricing-range-label">
                {{ 'landing.landing_1.pricing.tiers.' + tier.key + '.claims_label' | translate }}
              </span>
            </div>

            <div class="landing-a__pricing-fee">
              <span class="landing-a__pricing-fee-amount">
                {{ 'landing.landing_1.pricing.tiers.' + tier.key + '.fee' | translate }}
              </span>
              @if (!tier.contact) {
                <span class="landing-a__pricing-fee-period">
                  {{ 'landing.landing_1.pricing.period' | translate }}
                </span>
              }
            </div>
          </div>
        </article>
      }
    </div>

    <p class="landing-a__pricing-note">{{ 'landing.landing_1.pricing.note' | translate }}</p>

    <div class="landing-a__hero-actions landing-a__hero-actions--center">
      <a class="landing-a__btn landing-a__btn--primary landing-a__btn--lg" [href]="dashboardUrl()">
        {{ 'landing.landing_1.pricing.cta' | translate }}
      </a>
    </div>
  </div>
</section>
